import styled, { css } from 'styled-components';
import { NAVIGATION_VIEWPORT_BREAKPOINTS } from '../../../../navigation/constants';
import Typography from '../../../../typography';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
/**
 * Navigation action sheet link container
 */
export const navigationActionSheetLinkContainerStyles = ({ theme }) => css `
	display: flex;
	align-items: center;
	gap: ${pxToRem(theme.spacing['200'])};
	padding: ${pxToRem(theme.spacing['200'])} ${pxToRem(theme.spacing['100'])};
	color: ${theme.colors.base.textMainNavigation};
	text-decoration: none;

	&:hover {
		color: ${theme.colors.highlight.textHover};
		background-color: ${theme.colors.extralight.bgNavigationItemHover};
	}

	&:active {
		background-color: ${theme.colors.base.bgNavigationItemActive};
		color: ${theme.colors.blanc.textInverse};
	}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		padding: 0;

		&:hover {
			background-color: unset;
			color: ${theme.colors.highlight.textInteractiveOnLight};
		}

		&:focus {
			background-color: unset;
			color: unset;
		}

		&:active {
			color: ${theme.colors.action.textActive};
		}
	}

	&:focus-visible {
		outline: ${theme.borderWidth.m}px solid ${theme.colors.highlight.borderFocus};
		outline-offset: -${theme.borderWidth.m}px;
	}
`;
export const NavigationActionSheetLinkContainer = styled(Typography) `
	${navigationActionSheetLinkContainerStyles}
`;
